import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useChannelList } from '../../hooks/useChannelList';
import { logger } from '../../utils/logger';
import { Strings } from '../../constants/Strings';
import { CobuStack, CobuText, CobuLoader } from '@cobu/ui';

export default function ChatDmRedirect() {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const { navigateToChannel, isStreamAvailable } = useChannelList({ enabled: true });
  const strings = Strings.get();

  useEffect(() => {
    if (!userId) {
      navigate('/chat', { replace: true });
      return;
    }

    if (!isStreamAvailable) {
      navigate('/chat', { replace: true });
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const channel = await navigateToChannel(userId, '');
        if (cancelled) return;
        const target = channel?.cid || channel?.id;
        if (target) {
          navigate(`/chat/${target}`, { replace: true });
        } else {
          navigate('/chat', { replace: true });
        }
      } catch (err) {
        logger.error('Failed to open DM from deeplink:', err);
        if (!cancelled) {
          navigate('/chat', { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, isStreamAvailable, navigateToChannel, navigate]);

  // Simple loading fallback while we resolve the DM channel
  return (
    <CobuStack f={1} ai="center" jc="center" bg="$white">
      <CobuLoader />
      <CobuText mt="$3" variant="body" color="$colorMuted">
        {strings.common.loading}
      </CobuText>
    </CobuStack>
  );
}


